import { Dialog, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";

import InputField from "../../../components/InputField";
import Label from "../../../components/label";
import DialogHeader from "../../../components/dialog/DialogHeader";
import DialogBody from "../../../components/dialog/DialogBody";
import DialogActionButtons from "../../../components/dialog/DialogActions";
import { userCreateWithdrawRequest } from "../../../services/userDetailFn";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import { useSelector } from "react-redux";
import AppLoader from "../../../components/apploader";
import { t } from "i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing("24px"),
  },
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

let paramsData = {};

const WithdrawAmountDialog = forwardRef(({ handleConfirm }, ref) => {
  const { showSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [amountError, setAmountError] = useState(false);
  const userData = useSelector((state) => state.userReducer.user);

  console.log(paramsData, "sdsajdsajhdsadjhsajh");

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      paramsData = params;
      setOpen(true);
    },
    closeDialog() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setAmount("");
    setAmountError(false);
  };

  const handleRequest = async () => {
    if (amountError) return;

    try {
      const paylaod = {
        amount: amount,
        userId: userData?._id,
      };
      setIsLoading(true);
      const response = await userCreateWithdrawRequest(paylaod);
      if (response.data.status === "success") {
        paramsData.getData();
        handleClose();
        showSnackbar(response.data.message, "success");
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error updating bank details:", error);
      showSnackbar(t("bankUpdateFailed"), "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogHeader title={"withdrawRequest"} onClose={handleClose} />
        <DialogBody>
          <Grid container rowSpacing={2}>
            <Grid item xs={12}>
              <Label text={t("amount")} required htmlFor="withdraw_amount" />
              <InputField
                id={"withdraw_amount"}
                placeholder={t("enterWithdrawAmount")}
                type="number"
                name="amount"
                value={amount}
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  if (value < 0) return;
                  setAmount(value);
                  setAmountError(false);
                }}
                inputError={amountError}
                helperText={amountError && "Amount is required"}
              />
            </Grid>
          </Grid>
          <Typography variant="body1" fontWeight={500} my={2}>
            {t("confirmWithdrawRequest")}
          </Typography>
        </DialogBody>
        <DialogActionButtons
          onCancel={handleClose}
          onConfirm={() => {
            if (!amount || isNaN(amount) || amount <= 0) {
              setAmountError(true);
            } else {
              handleRequest();
            }
          }}
        />
      </BootstrapDialog>
    </>
  );
});

export default WithdrawAmountDialog;
